<template>
    <div class="content">
        <h2 class="h3">{{ t('title') }}</h2>
        <p>{{ !order.data.value.station ? t('text') : t('selectedStation') }} <strong>{{ selectedStation.name }}</strong></p>
        <DSInput
            v-model="search"
            trailing-icon="search"
            disable-icon-click
            :label="t('chooseStation')"
            :error="error"
        />
        <div
            v-for="station in filteredStations"
            :key="station.name"
            class="results"
        >
            <button
                class="result"
                :class="{active: selectedStation.name === station.name}"
                @click="selectStation(station.id)"
            >
                <div>{{ station.name }}</div>
            </button>
        </div>
    </div>
</template>
<script setup>
import { ref, computed, inject, useI18n } from '#imports';

const order = inject('order');

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            title: 'Missä haluatte syödä?',
            text: 'Valitse asema alla olevasta listasta',
            chooseStation: 'Hae asema',
            selectedStation: 'Valittu asema:',
        },
        'en-EU': {
            title: 'Missä haluatte syödä?',
            text: 'Valitse asema alla olevasta listasta',
            chooseStation: 'Hae asema',
        },
    },
});

defineOptions({
    inheritAttrs: false,
});

const props = defineProps({
    stations: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const selectedStation = computed(() => {
    if (order.data.value.station) {
        return props.stations.find(station => station.id === order.data.value.station);
    }

    return {};
});
const search = ref('');
const error = ref(null);

const filteredStations = computed(() => {
    if (search.value.length > 0 && props.stations.length > 0) {
        return props.stations.filter(station => station.name.toLowerCase().indexOf(search.value.toLowerCase()) >= 0);
    }

    return props.stations ?? [];
});

function selectStation(id = null) {
    order.data.value.station = id;
}
</script>
<style scoped>
.results {
  display: grid;
  border: 1px solid var(--color-base-grey-200);
  margin: 0.5rem 0;
  cursor: pointer;
}
.results .result {
  padding: 1rem 1.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  font-weight: bold;
  text-align: left;
}
.results .result :last-child {
  color: var(--color-primary-500);
  font-size: 0.875rem;
}
.results .active {
  transition: 250ms;
  background-color: var(--color-primary-500);
}
.results .active :first-child {
  color: var(--color-base-white);
}
.results .active :last-child {
  color: var(--color-base-white);
  font-size: 0.875rem;
}
</style>
